import { render, staticRenderFns } from "./OrderCodeDialog.vue?vue&type=template&id=badef2cc&scoped=true"
import script from "./OrderCodeDialog.vue?vue&type=script&lang=js"
export * from "./OrderCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderCodeDialog.vue?vue&type=style&index=0&id=badef2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badef2cc",
  null
  
)

export default component.exports